import { render, staticRenderFns } from "./gSwiperCommon.vue?vue&type=template&id=de9c75e2"
import script from "./gSwiperCommon.vue?vue&type=script&lang=js"
export * from "./gSwiperCommon.vue?vue&type=script&lang=js"
import style0 from "./gSwiperCommon.vue?vue&type=style&index=0&id=de9c75e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports